import axios from "axios";

// Configure axios base URL for backend API
const API_BASE_URL = process.env.REACT_APP_API_URL || "http://localhost:5001";

// Create axios instance with base configuration
const api = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    "Content-Type": "application/json",
  },
});

// Add request interceptor to include auth token
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("token");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Add response interceptor to handle auth errors and permission denials
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem("token");
      // Check if current path is for investor to redirect to correct login
      if (window.location.pathname.includes("investor")) {
        window.location.href = "/investor-login";
      } else {
        window.location.href = "/login";
      }
    }
    // Note: 403 errors are NOT automatically alerted here
    // Components should handle permission errors based on context
    // Use showPermissionAlert() from permissionService for explicit user actions
    return Promise.reject(error);
  }
);

export default api;
export { API_BASE_URL };
